/**
 * package: com.inq.utils
 * class: EventDataUtils
 * root Object
 * @constructor
 */
com.inq.utils.EventDataUtils = function() {};
$hxClasses['com.inq.utils.EventDataUtils'] = com.inq.utils.EventDataUtils;
/** @private @type {Array} */
com.inq.utils.EventDataUtils.__name__ = ["com","inq","utils","EventDataUtils"];

/**
 * fromMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TInst(com.inq.utils.Dictionary,[]))
 * public static function fromMessage(message:Message):Dictionary
 * @public
 * @static
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {com.inq.utils.Dictionary}
 */
com.inq.utils.EventDataUtils.fromMessage = function (message) {
	/** @type {com.inq.utils.Dictionary} */
	var eventData = new com.inq.utils.Dictionary();
	eventData["agtFirstName"] = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_EVENT_AGENT_FIRST_NAME);
	eventData["agtLastName"] = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_EVENT_AGENT_LAST_NAME);
	eventData["agtAttrs"] = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_SITE_ATTRS);
	eventData["agtCId"] = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USER_CID);
	haxe.Log.trace("DEBUG: agtAttrs has been populated as (" + eventData["agtAttrs"] + ")", {
		fileName: "EventDataUtils.hx",
		lineNumber: 27,
		className: "EventDataUtils",
		methodName: "fromMessage"
	});
	/** @type {?string} */
	var agentAlias = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_AGENT_ALIAS);
	if (agentAlias != null) {
		eventData["agentAlias"] = agentAlias;
	}
	/** @type {?string} */
	var firstRequestedAttr = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_EVENT_INITIAL_REQUEST_ATTRIBUTES);
	/*  First requested attribute contains comma as seporator instead "=". */
	if (firstRequestedAttr != null) {
		eventData["firstRequestedAttr"] = firstRequestedAttr.split(",").join("=");
	}
	/** @type {?string} */
	var newRequestedAttr = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_EVENT_TRANSFER_REQUEST_ATTRIBUTES);
	if (newRequestedAttr != null) {
		eventData["newRequestedAttr"] = newRequestedAttr;
	}
	return eventData;
};

/** @type {com.inq.utils.EventDataUtils} */
com.inq.utils.EventDataUtils.prototype.__class__ = com.inq.utils.EventDataUtils;
